function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.253,
    height: 22,
    viewBox: "0 0 20.253 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8497"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "bell (4)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40911",
    d: "M18 8A6 6 0 1 0 6 8c0 7-3 9-3 9h18s-3-2-3-9",
    transform: "translate(-1.75 -1)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40912",
    d: "M13.731 21a2 2 0 0 1-3.461 0",
    transform: "translate(-1.749 -.997)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8e17f2066c0ebc903fbbcf1b0a61564d.svg";
export { ForwardRef as ReactComponent };